import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllMotoristaCadastro } from '../service';
import {
  LIST_MOTORISTA_CADASTRO,
  LIST_MOTORISTA_CADASTRO_PENDING,
  LIST_MOTORISTA_CADASTRO_SUCCESS,
  LIST_MOTORISTA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllMotoristaCadastro(action) {
  yield put({ type: LIST_MOTORISTA_CADASTRO_PENDING })

  try {
    const list = yield call(findAllMotoristaCadastro)
    
    yield put({ type: LIST_MOTORISTA_CADASTRO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_MOTORISTA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllMotoristaCadastro() {
  yield takeLatest(LIST_MOTORISTA_CADASTRO, sagaListAllMotoristaCadastro)
}